import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button']
  static values = {
    messageCache: String
  }

  disable (event) {
    this.submitter = event.detail.formSubmission.submitter
    this.messageCacheValue = this.submitter.innerHTML
    const disableText = this.submitter.dataset.multiSubmitDisableParam

    this.buttonTargets.forEach(button => {
      button.disabled = true

      if (button === this.submitter) {
        button.innerHTML = disableText
      }
    })
  }

  reset () {
    this.buttonTargets.forEach(button => {
      button.disabled = false

      if (button === this.submitter) {
        button.innerHTML = this.messageCacheValue
      }
    })

    this.submitter = null
    this.messageCacheValue = null
  }
}
